<template>
  <div class="form-link-npa">
    <v-btn class="btn-add-category" :aria-label="$t('Добавить контактное лицо')" @click.native.stop="personDialog = true">
      <span class="pro-icon-add" aria-hidden="true"></span>
    </v-btn>
    <v-dialog v-model="personDialog" max-width="400">
      <v-card class="modal">
        <div class="modal-head">
          {{ $t('Контактные лица') }}
          <v-btn color="modal-close" :aria-label="$t('Закрыть')" @click.native="personDialog = false">
            <span class="pro-icon-close1" aria-hidden="true"></span>
          </v-btn>
        </div>
        <div class="modal-body">
          <div :class="{invalid: $v.person.fullName.$error}">
            <v-text-field
              v-model="person.fullName"
              outlined
              rounded
              dense
              ref="nameField"
              placeholder="ФИО"
              :aria-label="$t('ФИО')"
              :aria-invalid="$v.person.fullName.$error ? 'true' : 'false'"
              :error-messages="fullNameErrors"
              @input="$v.person.fullName.$touch()"
              @blur="$v.person.fullName.$touch()"
            />
          </div>
          <div :class="{invalid: $v.person.position.$error}">
            <v-text-field
              v-model="person.position"
              outlined
              rounded
              dense
              ref="positionField"
              placeholder="Должность"
              :aria-label="$t('Должность')"
              :aria-invalid="$v.person.position.$error ? 'true' : 'false'"
              :error-messages="positionErrors"
              @input="$v.person.position.$touch()"
              @blur="$v.person.position.$touch()"
            />
          </div>
          <div :class="{invalid: $v.person.phone.$error}">
            <v-text-field
              v-model="person.phone"
              outlined
              rounded
              dense
              ref="phoneField"
              placeholder="Номер телефона"
              :aria-label="$t('Номер телефона')"
              :aria-invalid="$v.person.phone.$error ? 'true' : 'false'"
              :error-messages="phoneErrors"
              @input="$v.person.phone.$touch()"
              @blur="$v.person.phone.$touch()"
            />
          </div>
          <v-btn rounded color="primary" dark @click="fetchPersons">
            {{ $t('Добавить') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <ul>
      <li v-for="(item, index) of personList" :key="index">
        <span>{{ item.fullName }} {{ item.position }} {{ item.phone }}</span>
        <span
          class="pro-icon-close"
          role="button"
          tabindex="0"
          :aria-label="$t('Удалить') + ': ' + item.fullName"
          @click="deletePerson(index)"
          @keydown.enter.prevent="deletePerson(index)"
          @keydown.space.prevent="deletePerson(index)"
        ></span>
      </li>
    </ul>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  props: {
    authorData: {
      type: Object,
      required: false
    },
    personsLength: {
      type: Number,
      required: false
    }
  },
  data: () => ({
    person: {
      fullName: '',
      position: '',
      phone: '',
    },
    personList: [],
    personDialog: false
  }),
  validations: {
    person: {
      fullName: { required },
      position: { required },
      phone: { required }
    }
  },
  computed: {
    fullNameErrors() {
      const errors = []
      if (!this.$v.person.fullName.$dirty) return errors
      !this.$v.person.fullName.required && errors.push(this.$t('Поле обязательно для заполнения'))
      return errors
    },
    positionErrors() {
      const errors = []
      if (!this.$v.person.position.$dirty) return errors
      !this.$v.person.position.required && errors.push(this.$t('Поле обязательно для заполнения'))
      return errors
    },
    phoneErrors() {
      const errors = []
      if (!this.$v.person.phone.$dirty) return errors
      !this.$v.person.phone.required && errors.push(this.$t('Поле обязательно для заполнения'))
      return errors
    }
  },
  mounted() {
    if (this.$props.personsLength === 0 && this.$props.authorData) {
      this.person.fullName = this.$props.authorData.fullName
      this.person.position = this.$props.authorData.position
      this.person.phone = this.$props.authorData.phone
    }
  },
  watch: {
    personsLength(newVal) {
      if (newVal === 0 && this.authorData) {
        this.person.fullName = this.authorData.fullName
        this.person.position = this.authorData.position
        this.person.phone = this.authorData.phone
      }
    }
  },
  methods: {
    fetchPersons() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.personList.push({ ...this.person })

      this.$emit('fetchPersons', this.personList)

      this.person = {
        fullName: '',
        position: '',
        phone: ''
      }

      this.$v.$reset()

      this.personDialog = false
    },
    resetPersons() {
      this.personList = []
      this.person = {
        fullName: '',
        position: '',
        phone: ''
      }
      this.$v.$reset()
      this.personDialog = false
    },
    deletePerson(index) {
      this.personList.splice(index, 1)
      this.$emit('fetchPersons', this.personList)
    }
  }
}
</script>
